import FormColorControl from './FormColorControl';
import React, { memo, useCallback } from 'react';
import { IColor } from '../../interfaces';
import { formActions, useAppDispatch, useAppSelector } from '../../data/store';

const BackgroundColor = () => {

    const dispatch = useAppDispatch();
    const backgroundColor = useAppSelector(store => store.form.backgroundColor);

    const updateBackgroundColor = useCallback((updatedColor: IColor) => {
        dispatch(
            formActions.main({
                backgroundColor: updatedColor,
            })
        );
    }, [dispatch]);

    return (
        <FormColorControl
            title={ 'Background Color' }
            rgbaColor={ backgroundColor }
            onChange={ updateBackgroundColor }
        />
    )
};

export default memo(BackgroundColor);